var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _vm.modalActive
      ? _c(
          "div",
          {
            staticClass: "test",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                _vm.close()
              }
            }
          },
          [
            _c("div", { staticClass: "modal-mask" }, [
              _c("div", { staticClass: "modal-wrapper" }, [
                _c("div", { staticClass: "modal-container" }, [
                  _c(
                    "div",
                    { staticClass: "modal-header" },
                    [
                      _vm._t("header", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.title) +
                            "\n                        "
                        )
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-body" },
                    [
                      _vm._t("body", [
                        _vm._v(
                          "\n                            default body\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "section",
                        [
                          _c(_vm.component, {
                            tag: "component",
                            attrs: {
                              content: JSON.stringify(_vm.componentData)
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-footer pr-0" },
                    [
                      _vm._t("footer", [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-secondary waves-effect waves-light",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: {
                              click: function($event) {
                                _vm.close()
                              }
                            }
                          },
                          [_vm._v("Close\n                            ")]
                        )
                      ])
                    ],
                    2
                  )
                ])
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33bd6922", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33bd6922","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/notifications/modal.vue
// module id = 331
// module chunks = 0